import { useTranslation } from 'react-i18next'

type Language = 'en' | 'de'

export const useLanguage = (): 'en' | 'de' => {
  const { i18n } = useTranslation()

  return i18n.language as Language
}
